import { useEffect, useState } from "react";

const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

export function usePwaInstall() {
  const [prompt, setPrompt] = useState(() => window.__deferredInstallPrompt || null);
  const [installed, setInstalled] = useState(isStandalone);

  useEffect(() => {
    const onReady = () => setPrompt(window.__deferredInstallPrompt || null);
    const onInstalled = () => setInstalled(true);
    window.addEventListener("pwa-prompt-ready", onReady);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("pwa-prompt-ready", onReady);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const install = async () => {
    if (!prompt) return false;
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    window.__deferredInstallPrompt = null;
    setPrompt(null);
    return outcome === "accepted";
  };

  return { canPrompt: !!prompt, installed, install };
}
